export default __webpack_public_path__ + "static/media/bento-illustration.288f4249.png";